export default {
    create_company_modal: {
        title: 'Create company',
    },
    change_password: {
        title: 'Change password',
    },
    change_email: {
        title: 'Change email',
    },
    change_phone: {
        title: 'Change phone',
    },
    verify_phone: {
        title: 'Verify phone number',
    },
    add_credentials: {
        title: 'Add credentials',
    },
    add_password: {
        title: 'Add password',
    },
    invite_company_user: {
        title: 'Invite company user',
    },
    change_role_company_user: {
        title: 'Change role for company user',
    },
    delete_offer: {
        title: 'Are you sure you want to delete the service?',
    },
    delete_discount: {
        title: 'Are you sure you want to delete the discount?',
    },
    extend_offer: {
        title: 'Are you sure you want to extend the service?',
    },
    delete_company_user: {
        title: 'Are you sure you want to delete a company user?',
    },
    confirm_reservation_modal: {
        add_note: 'Add note...',
        reservation_succeeded:
            'Congradulations! You have made the reservation. You will be notified when your booking is accepted.',
        reschedule_succeeded: 'Congradulations! You sucessfully rescheduled the event.',
        blocked_reservation: 'Reservations for this service are only possible by phone!',
        slot_taken: 'Slot is taken! Please select another one.',
        user_blocked: 'Company has blocked this account!',
        two_hours_ahead: 'This slot cannot be booked. Please choose a time at least two hours ahead.',
        location: 'Location',
        date_and_time: 'Date and time',
        price: 'Price',
        confirm_reservation: 'Please confrim your reservation',
        reservation_confirmed_info: 'Thank you. The reservation has been sent.',
        reservation_confirmed_heading: 'Appointment successfully booked!',
        reservation_confirmed_subtitle:
            'You can view the status of your reservation in My Reservations - Created. After confirmation or any changes in the reservation status, you will be notified via email.',
        owner_reservation_confirmed_subtitle:
            'Your reservation has been successfully created. Thank you for using Bookeraj! Enjoy your work.',
        mins_ahead_7200: 'This slot cannot be booked. Please choose a time that is at least five days ahead.',
        mins_ahead_5760: 'This slot cannot be booked. Please choose a time that is at least four days ahead.',
        mins_ahead_4320: 'This slot cannot be booked. Please choose a time that is at least three days ahead.',
        mins_ahead_2880: 'This slot cannot be booked. Please choose a time that is at least two days ahead.',
        mins_ahead_1440: 'This slot cannot be booked. Please choose a time that is at least one day ahead.',
        mins_ahead_240: 'This slot cannot be booked. Please choose a time at least four hours ahead.',
        mins_ahead_180: 'This slot cannot be booked. Please choose a time at least three hours ahead.',
        mins_ahead_120: 'This slot cannot be booked. Please choose a time at least two hours ahead.',
        mins_ahead_90: 'This slot cannot be booked. Please choose a time at least hour and a half ahead.',
        mins_ahead_60: 'This slot cannot be booked. Please choose a time at least one hour ahead.',
        mins_ahead_45: 'This slot cannot be booked. Please choose a time at least 45 minutes ahead.',
        mins_ahead_30: 'This slot cannot be booked. Please choose a time at least 30 minutes ahead.',
        mins_ahead_20: 'This slot cannot be booked. Please choose a time at least 20 minutes ahead.',
        mins_ahead_15: 'This slot cannot be booked. Please choose a time at least 15 minutes ahead.',
        mins_ahead_10: 'This slot cannot be booked. Please choose a time at least 10 minutes ahead.',
        mins_ahead_5: 'This slot cannot be booked. Please choose a time at least 5 minutes ahead.',
        mins_ahead_1: 'This slot cannot be booked. Please choose a time at least 1 minute ahead.',
    },
    custom_reservation_modal: {
        info: 'Free booking allows you to book the service even outside of working hours, providing you with maximum flexibility, overlapping and free choice of the start of the appointment.',
    },
    out_of_availability_modal: {
        warning: 'Some of your reservations will be rescheduled due to the availability change',
        falling_out: `Are you sure you want to change?`,
        offer_name: 'Service: {name}',
        number_rescheduled_reservations: 'Number of reservations to reschedule: {n}',
    },
    add_inactivity_modal: {
        multi_select_input: {
            label_input: 'Schedule',
            placeholder_input: `Chose schedules`,
        },
        checkbox_label: 'Do you want to set inactivity for all services that contains this availability?',
    },
    complete_profile_modal: {
        create_company_service: 'To use this option you need to complete your profile! ',
        complete_first_and_last_name: 'To use this option you need to fill in your first and last name!',
        complete_mobile_phone: 'To use this option you need to fill in your mobile phone!',
    },
    add_inactivity: {
        title: 'Add inactivity',
    },
    remove_inactivity: {
        title: 'Are you sure you want to delete inactivity?',
    },
    location_used_modal: {
        title: 'This location cannot be deleted!',
        warning: 'You must remove this location from the following services:',
    },
    delete_location: {
        title: 'Are you sure you want to delete this location?',
    },
    add_availability: {
        heading: 'Ented the schedule details',
    },
    complete_profile: {
        heading: 'Please complete your profile',
        description: 'This data is mandatory to allow booking of services!',
        steps: {
            step_1: 'First and last name',
            step_2: 'Mobile',
        },
    },
    cookies: {
        message: 'Our lawyers advised us to tell you that we use cookies to improve user experience.',
        button: 'I like cookies',
    },
}
